// extracted by mini-css-extract-plugin
export var col = "grid-module--col--a7f34";
export var columns2 = "grid-module--columns2--a7b17";
export var columns3 = "grid-module--columns3--7de35";
export var container = "grid-module--container--580eb";
export var row = "grid-module--row--fe96d";
export var span2 = "grid-module--span2--b905a";